import { render } from "./BaseSortArrow.vue?vue&type=template&id=ebf24d74"
import script from "./BaseSortArrow.vue?vue&type=script&lang=ts"
export * from "./BaseSortArrow.vue?vue&type=script&lang=ts"
script.render = render

export default script